import styled from 'styled-components';
import React from 'react';
import { Box } from '@mui/material';
import { B2B_URL } from '../../../utils/constans/constans';

const LogoWrapper = styled(Box)(() => ({
    flex: 1,
    img: {
        maxWidth: '250px',
    },
    '@media (max-width: 1440px)': {
        maxWidth: '230px',
    },
}));

export const LogoWrapperB2B = () => {
    return (
        <LogoWrapper>
            <a href={B2B_URL}>
                <img src="/assets/MESTER_SZERELVENYOLT_logo_RGB.svg" />
            </a>
        </LogoWrapper>
    );
};
